<template>
<div class="as-root" :style="themePageStyle">

  <nav class="as-topbar"><div class="container d-flex align-items-center justify-content-between py-2">
    <div class="d-flex align-items-center" style="gap:12px;">
      <back-button class="me-2" />
      <a href="javascript:void(0)" @click="$router.push('/dashboard')"><img src="/assets/images/flockr_logo.png" alt="Flockr" style="height:34px;" /></a>
      <span class="fw-semibold" style="color:var(--fm-h,#F5F0E8);font-size:15px;">{{ hasShop ? 'My Agro Shop' : 'Set up your Agro Shop' }}</span>
    </div>
    <div class="d-flex gap-2" v-if="hasShop">
      <button class="btn btn-sm btn-outline-warning" @click="$router.push('/sell/products')"><i class="mdi mdi-package-variant me-1"></i>My Products</button>
    </div>
  </div></nav>

  <div class="container as-container">
    <div v-if="loading" class="text-center py-5"><div class="spinner-border text-warning"></div></div>

    <div v-else style="max-width:680px;margin:0 auto;">
      <!-- Intro / KYC banner -->
      <div class="as-hero mb-4">
        <h4 class="fw-bold m-0" style="color:var(--fm-h,#F5F0E8);"><i class="mdi mdi-storefront me-2" style="color:#BFA164;"></i>{{ hasShop ? form.shop_name : 'Register your Agro Shop' }}</h4>
        <p style="color:var(--fm-s,#6B6356);font-size:13px;margin:6px 0 0;">
          Set up your shop profile once. After this you can list feeds, vet drugs, seeds and equipment, and buyers will see them in the Agro-Input Shop under your shop name.
        </p>
        <div v-if="hasShop" class="mt-3 d-flex align-items-center gap-2">
          <span class="as-kyc" :class="'as-kyc-'+(form.kyc_status||'pending')">
            <i class="mdi" :class="form.kyc_status==='verified'?'mdi-check-decagram':(form.kyc_status==='rejected'?'mdi-close-octagon':'mdi-clock-outline')"></i>
            KYC {{ humanize(form.kyc_status||'pending') }}
          </span>
          <span style="color:var(--fm-s,#6B6356);font-size:11px;" v-if="(form.kyc_status||'pending')==='pending'">Verification reviewed by Flockr — you can still list products meanwhile.</span>
        </div>
      </div>

      <div class="as-card">
        <!-- Logo -->
        <div class="d-flex align-items-center gap-3 mb-3">
          <div class="as-logo" :style="logoPreview ? 'background-image:url('+logoPreview+')' : (form.logo_url ? 'background-image:url('+imgUrl(form.logo_url)+')' : '')">
            <i v-if="!logoPreview && !form.logo_url" class="mdi mdi-storefront-outline" style="font-size:30px;color:var(--fm-s,#6B6356);"></i>
          </div>
          <div>
            <label class="btn btn-sm btn-outline-warning" style="margin:0;cursor:pointer;"><i class="mdi mdi-image-plus me-1"></i>{{ form.logo_url||logoPreview ? 'Change logo' : 'Add logo' }}<input type="file" accept="image/*" style="display:none;" @change="onLogo" /></label>
            <div style="color:var(--fm-s,#6B6356);font-size:10px;margin-top:4px;">Square image works best</div>
          </div>
        </div>

        <div class="mb-2"><label class="as-label">Shop name *</label><input v-model="form.shop_name" class="as-input w-100" placeholder="e.g. Malunga Agrovet" /></div>

        <div class="row g-2 mb-2">
          <div class="col-md-6"><label class="as-label">Shop type *</label>
            <select v-model="form.shop_type" class="as-input w-100">
              <option value="agrovet">Agrovet (vet drugs + inputs)</option>
              <option value="feed_store">Feed / supplement store</option>
              <option value="seeds_inputs">Seeds &amp; crop inputs</option>
              <option value="equipment">Equipment &amp; tools</option>
              <option value="general">General agro-dealer</option>
            </select>
          </div>
          <div class="col-md-6"><label class="as-label">Business / license no.</label><input v-model="form.license_number" class="as-input w-100" placeholder="Permit / KRA PIN (optional)" /></div>
        </div>

        <div class="mb-2"><label class="as-label">Description</label><textarea v-model="form.description" class="as-input w-100" rows="2" placeholder="What you stock, brands you carry, etc."></textarea></div>

        <div class="row g-2 mb-2">
          <div class="col-md-6"><label class="as-label">Phone</label><input v-model="form.phone" class="as-input w-100" placeholder="2547..." /></div>
          <div class="col-md-6"><label class="as-label">Email</label><input v-model="form.email" class="as-input w-100" type="email" placeholder="shop@email.com" /></div>
        </div>

        <div class="row g-2 mb-2">
          <div class="col-md-6"><label class="as-label">County</label>
            <select v-model="form.county_id" class="as-input w-100"><option value="">Select county...</option><option v-for="c in counties" :key="c.id" :value="c.id">{{ c.name }}</option></select>
          </div>
          <div class="col-md-6"><label class="as-label">Physical address</label><input v-model="form.physical_address" class="as-input w-100" placeholder="Town / building / stall" /></div>
        </div>

        <div class="mb-3"><label class="as-label">Opening hours</label><input v-model="form.opening_hours" class="as-input w-100" placeholder="e.g. Mon-Sat 8am - 6pm" /></div>

        <button class="btn btn-warning w-100" @click="save" :disabled="!form.shop_name||!form.shop_type||saving">
          <span v-if="saving"><span class="spinner-border spinner-border-sm me-1"></span>Saving...</span>
          <span v-else><i class="mdi mdi-content-save me-1"></i>{{ hasShop ? 'Save changes' : 'Create my shop' }}</span>
        </button>
        <button v-if="hasShop" class="btn btn-sm btn-link text-warning w-100 mt-2" @click="$router.push('/sell/products')">Go to my products →</button>
      </div>
    </div>
  </div>
</div>
</template>

<style>
:root{--fm-h:#F5F0E8;--fm-s:#6B6356;--fm-m:#A09888;--fm-bg1:#141414;--fm-bg2:#0F0F0F;--fm-bg3:#1E1E1E;--fm-br:#1E1E1E}
html[data-theme="light"]{--fm-h:#1A1A1A;--fm-s:#777;--fm-m:#555;--fm-bg1:#FFFFFF;--fm-bg2:#F7F5F2;--fm-bg3:#F0EBE4;--fm-br:#E8E2DA}
html[data-theme="light"] .as-root{background:#F7F5F2!important;color:#1A1A1A!important}
html[data-theme="light"] .as-topbar{background:rgba(255,255,255,.95)!important;border-bottom-color:#E8E2DA!important}
html[data-theme="light"] .as-card,html[data-theme="light"] .as-hero{background:#FFFFFF!important;border-color:#E8E2DA!important}
html[data-theme="light"] .as-input{background:#F7F5F2!important;border-color:#E0D8D0!important;color:#1A1A1A!important}
</style>

<style scoped>
.as-root{background:var(--fm-bg2,#0A0A0A);min-height:100vh;color:var(--fm-h,#F5F0E8)}
.as-topbar{position:sticky;top:0;z-index:100;padding:12px 0;background:var(--fm-bg1,#141414);backdrop-filter:blur(10px);border-bottom:1px solid var(--fm-br,#1E1E1E)}
.as-container{padding-top:80px;padding-bottom:60px}
.as-hero{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:12px;padding:18px}
.as-card{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:12px;padding:18px}
.as-label{display:block;font-size:11px;color:var(--fm-s,#6B6356);text-transform:uppercase;letter-spacing:.3px;margin-bottom:4px;font-weight:600}
.as-input{background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#2A2520);border-radius:8px;padding:9px 12px;color:var(--fm-h,#F5F0E8);font-size:13px}
.as-input:focus{outline:none;border-color:#BFA164}
.as-logo{width:72px;height:72px;border-radius:12px;background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#1E1E1E);background-size:cover;background-position:center;display:flex;align-items:center;justify-content:center;flex-shrink:0}
.as-kyc{font-size:11px;font-weight:700;padding:3px 10px;border-radius:20px;display:inline-flex;align-items:center;gap:4px}
.as-kyc-pending{background:rgba(241,180,76,.16);color:#f1b44c}
.as-kyc-verified{background:rgba(80,200,120,.16);color:#50C878}
.as-kyc-rejected{background:rgba(255,107,107,.16);color:#FF6B6B}

/* ===== MOBILE — feels-like-an-app ===== */
@media (max-width: 768px) {
  .as-container { padding-top: 70px !important; padding-bottom: calc(80px + env(safe-area-inset-bottom, 0px)) !important; padding-left: 12px !important; padding-right: 12px !important; }
  .as-card { padding: 14px !important; border-radius: 10px !important; }
  .as-input { font-size: 16px !important; padding: 10px 12px !important; }
  .as-logo { width: 60px; height: 60px; }
  .as-kyc { font-size: 10px; padding: 2px 8px; }
}
</style>

<script>
/* eslint-disable */
import { execute, executeJson, flocker, uploads } from "@/api";
export default {
  name: "AgroShopOnboarding",
  data(){return{
    darkMode:(document.documentElement.getAttribute('data-theme')||localStorage.getItem('flockr_theme')||'dark')!=='light',
    themeObserver:null, loading:true, saving:false, hasShop:false,
    counties:[], logoFile:null, logoPreview:'',
    form:{ shop_name:'', shop_type:'agrovet', description:'', phone:'', email:'', county_id:'', physical_address:'', license_number:'', opening_hours:'', logo_url:'', kyc_status:'pending' }
  }},
  computed:{
    themePageStyle(){return this.darkMode?'background:#0A0A0A;min-height:100vh;color:#F5F0E8;':'background:#F7F5F2;min-height:100vh;color:#1A1A1A;'}
  },
  mounted(){
    this._applyThemeOnce();
    var self=this;
    this.themeObserver=new MutationObserver(function(){try{self._applyThemeOnce();}catch(e){}});
    this.themeObserver.observe(document.documentElement,{attributes:true,attributeFilter:['data-theme']});
    if(!sessionStorage.getItem('userId')){this.$router.push('/login?redirect=/sell/shop');return}
    this.load();
  },
  beforeUnmount(){if(this.themeObserver){this.themeObserver.disconnect();this.themeObserver=null}},
  methods:{
    _applyThemeOnce(){
      var current=document.documentElement.getAttribute('data-theme');
      var desired=(localStorage.getItem('flockr_theme')||current||'dark');
      if(current!==desired) document.documentElement.setAttribute('data-theme',desired);
      this.darkMode=desired!=='light';
    },
    imgUrl(u){if(!u)return'';if(String(u).indexOf('http')===0)return u;return uploads+String(u).replace(/^uploads\//,'');},
    humanize(s){return (s||'').replace(/_/g,' ').replace(/\b\w/g,function(c){return c.toUpperCase()})},
    async load(){
      this.loading=true;
      try{
        var cr=await executeJson({function:'getCounties',countryCode:'KE'},flocker);
        if(cr.data&&cr.data.success)this.counties=(cr.data.data&&cr.data.data.counties)||[];
        var r=await executeJson({function:'getMyAgroShop',ownerId:sessionStorage.getItem('userId')},flocker);
        if(r.data&&r.data.success&&r.data.data&&r.data.data.shop){
          var s=r.data.data.shop;this.hasShop=true;
          this.form={ shop_name:s.shop_name||'', shop_type:s.shop_type||'agrovet', description:s.description||'', phone:s.phone||'', email:s.email||'', county_id:s.county_id||'', physical_address:s.physical_address||'', license_number:s.license_number||'', opening_hours:s.opening_hours||'', logo_url:s.logo_url||'', kyc_status:s.kyc_status||'pending' };
        }
      }catch(e){console.error(e)}
      this.loading=false;
    },
    onLogo(e){var f=e.target.files&&e.target.files[0];if(!f)return;this.logoFile=f;this.logoPreview=URL.createObjectURL(f);},
    async save(){
      if(!this.form.shop_name||!this.form.shop_type)return;
      this.saving=true;
      try{
        var fd=new FormData();
        fd.append('function','saveAgroShop');
        fd.append('ownerId',sessionStorage.getItem('userId'));
        fd.append('shopName',this.form.shop_name);
        fd.append('shopType',this.form.shop_type);
        fd.append('description',this.form.description||'');
        fd.append('phone',this.form.phone||'');
        fd.append('email',this.form.email||'');
        fd.append('countyId',this.form.county_id||'');
        fd.append('physicalAddress',this.form.physical_address||'');
        fd.append('licenseNumber',this.form.license_number||'');
        fd.append('openingHours',this.form.opening_hours||'');
        if(this.logoFile)fd.append('logo',this.logoFile);
        var r=await execute(fd,flocker);
        if(r.data&&r.data.success){
          var first=!this.hasShop;this.hasShop=true;this.logoFile=null;
          await this.load();
          alert(first?'Shop created — you can now list products':'Shop updated');
          this.$router.push('/sell/dashboard');
        }else alert((r.data&&r.data.message)||'Failed to save shop');
      }catch(e){alert('Network error')}
      this.saving=false;
    }
  }
};
</script>
